import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center text-blue-300 hover:text-blue-200 transition-colors mb-4"
          >
            ← {t('backToHome', 'Back to Home')}
          </Link>
          <h1 className="text-4xl font-bold mb-4">{t('footer.privacyPolicy')}</h1>
          <p className="text-gray-300">
            {t('privacyPolicy.lastUpdated', 'Last updated: January 2025')}
          </p>
        </div>

        {/* Content */}
        <div className="max-w-4xl space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('privacyPolicy.informationCollection.title', '1. Information We Collect')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('privacyPolicy.informationCollection.content',
                'We collect information you provide directly to us, such as when you subscribe to our updates, contact us, or use our services. This may include your email address, name, and any other information you choose to provide.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('privacyPolicy.useOfInformation.title', '2. How We Use Your Information')}
            </h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              {t('privacyPolicy.useOfInformation.content',
                'We use the information we collect to:'
              )}
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>{t('privacyPolicy.useOfInformation.item1', 'Provide and improve our services')}</li>
              <li>{t('privacyPolicy.useOfInformation.item2', 'Send you updates and communications')}</li>
              <li>{t('privacyPolicy.useOfInformation.item3', 'Respond to your inquiries and support requests')}</li>
              <li>{t('privacyPolicy.useOfInformation.item4', 'Analyze usage patterns and improve user experience')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('privacyPolicy.dataProtection.title', '3. Data Protection')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('privacyPolicy.dataProtection.content',
                'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Your data is stored securely and we follow industry best practices for data protection.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('privacyPolicy.cookies.title', '4. Cookies and Tracking')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('privacyPolicy.cookies.content',
                'We use cookies and similar technologies to enhance your experience, analyze site usage, and personalize content. You can manage your cookie preferences through your browser settings.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('privacyPolicy.thirdParty.title', '5. Third-Party Services')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('privacyPolicy.thirdParty.content',
                'We may use third-party services for analytics, hosting, and other purposes. These services may collect information about your use of our website. Please review their privacy policies for more information.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('privacyPolicy.yourRights.title', '6. Your Rights')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('privacyPolicy.yourRights.content',
                'You have the right to access, update, or delete your personal information. You may also unsubscribe from our communications at any time. To exercise these rights, please contact us using the information below.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('privacyPolicy.contact.title', '7. Contact Us')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('privacyPolicy.contact.content',
                'If you have any questions about this Privacy Policy, please contact us at: '
              )}
              <a
                href="mailto:toby.brooks@tobybrooks.com"
                className="text-blue-300 hover:text-blue-200 transition-colors"
              >
                toby.brooks@tobybrooks.com
              </a>
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-gray-600">
          <p className="text-center text-gray-400">
            © 2025 Toby Brooks. {t('footer.allRightsReserved', 'All rights reserved.')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;